export default __webpack_public_path__ + "static/media/ProgressLogo.8f1be2f9.svg";